import { Button } from "components/DesignSystem/Button/Button";
import { motion } from "framer-motion";
import { useModal } from "hooks/useModal";
import { Task1120BulkETDUpdateModal } from "./Task1120BulkETDUpdateModal";
import { Task1120BulkPreparerUpdateModal } from "./Task1120BulkPreparerUpdateModal";
import { Task1120BulkServiceTeamUpdateModal } from "./Task1120BulkServiceTeamUpdateModal";

export const PREPARER = "preparer_id";
export const SERVICE_TEAM = "service_team_id";
export const ETD = "estimated_delivery_time";

export type Task1120BulkActionConfig = {
  title: string;
  label: string;
  placeholder: string;
  toastTitle: string;
  toastMessage: string;
  loadingMessage: string;
};

type Task1120BulkActionProps = {
  selectedRows: string[];
  resetSelection: () => void;
  selectedRowsServiceTeam: string[];
};

export const Task1120BulkAction = ({
  selectedRows,
  resetSelection,
  selectedRowsServiceTeam,
}: Task1120BulkActionProps) => {
  const canAddETD = selectedRowsServiceTeam.length === selectedRows.length;
  const canAssignPreparer =
    canAddETD && new Set(selectedRowsServiceTeam).size === 1;
  const serviceTeamAssignModal = useModal();
  const preparerAssignModal = useModal();
  const estimatedDeliveryTimeModal = useModal();

  return (
    <>
      <motion.span
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ ease: "easeInOut", duration: 0.2 }}
        key={selectedRows.toString()}
        className="t-flex t-gap-3 t-items-center"
      >
        <div className="t-text-subtext t-text-text-30">Update:</div>
        <Button size="small" onClick={serviceTeamAssignModal.open}>
          Service Team
        </Button>
        <Button
          size="small"
          onClick={estimatedDeliveryTimeModal.open}
          disabled={!canAddETD}
        >
          ETD
        </Button>
        <Button
          size="small"
          onClick={preparerAssignModal.open}
          disabled={!canAssignPreparer}
        >
          Preparer
        </Button>
      </motion.span>
      <Task1120BulkServiceTeamUpdateModal
        {...serviceTeamAssignModal}
        selectedRows={selectedRows}
        resetSelection={resetSelection}
      />
      <Task1120BulkPreparerUpdateModal
        {...preparerAssignModal}
        selectedRows={selectedRows}
        resetSelection={resetSelection}
        serviceTeamId={selectedRowsServiceTeam?.[0]}
      />
      <Task1120BulkETDUpdateModal
        {...estimatedDeliveryTimeModal}
        selectedRows={selectedRows}
        resetSelection={resetSelection}
      />
    </>
  );
};
